import { css } from '@linaria/core';
import theme from '../../../theme';

export const components = {
  bar: css``,
  fill: css``,
};

export const variants = {
  rookie: css`
    background-image: ${theme.gradients.rookie()};
  `,
  creator: css`
    background-image: ${theme.gradients.creator()};
  `,
  influencer: css`
    background-image: ${theme.gradients.influencer()};
  `,
  unicorn: css`
    background-image: ${theme.gradients.unicorn()};
  `,
  star: css`
    background-image: ${theme.gradients.star()};
  `,
};

export const progressBar = css`
  width: 100%;
  border-width: 2px;
  border-radius: 96px;
  background: ${theme.colors.neutral['30']};
  overflow: visible;
  display: flex;

  --progress-bar-color: ${theme.colors.primary['95']};

  & .${components.bar} {
    background-color: var(--progress-bar-color);
    border-radius: 6px;
  }

  & .${components.fill} {
    flex: 1;
  }

  border-radius: 6px;
  overflow: hidden;
  border-width: 0px;
  height: 12px;
`;
